import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {ResidentDateRangeOptions} from '../../utils/exportOptions';
import DateRangeOptionsFields from './DateRangeOptionsFields';
import ResidentOptionsFields from './ResidentOptionsFields';

const ResidentDateRangeOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<ResidentDateRangeOptions>) => (
  <>
    <ResidentOptionsFields form={form} />
    <DateRangeOptionsFields form={form} />
  </>
);

export default ResidentDateRangeOptionsFields;
